import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { DBDef_FHIRResource } from '@app/fhir-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
export const dispatch_onFHIRResourcesUpdated = new ThunderDispatcherV3('__onFHIRResourcesUpdated');
export class ModuleFE_FHIRResourceGroup_Class extends ModuleFE_BaseApi {
    constructor() {
        super(DBDef_FHIRResource, dispatch_onFHIRResourcesUpdated);
    }
    // ######################## Search ########################
    __searchFilterMapper = (item) => {
        return [item.label];
    };
    __searchGroups = (items, filter) => {
        return [{
                group: this.dbDef.dbKey, results: items.map(item => ({
                    _id: item._id,
                    uiLabel: item.label
                }))
            }];
    };
}
export const ModuleFE_FHIRResource = new ModuleFE_FHIRResourceGroup_Class();
//# sourceMappingURL=ModuleFE_FHIRResource.js.map